module.exports = __webpack_public_path__ + "static/img/14.9701963.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/zh/14.png
// module id = Rw/S
// module chunks = 0